import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { MessageBox } from 'mint-ui';
import { platform } from 'os';
declare var FileTransfer;
declare var LocalFileSystem;
declare var apkInstaller;
declare var webIntent;
declare var cordova;
/**
 * 升级
 */
@Component({

})
export default class UpgradeApp extends Vue {
  @Prop()
  public upgrade: {
    version: string,
    display: boolean,
    content: string,
    address: string,
  };
  public progress = 0;
  public platformName: string = '';

  public mounted() {
    this.platformName = window.platform.name;
  }

  public  handleUpdateVersion() {

    if (window.platform.name === 'android') {
      this.updateAndroid(this.upgrade.address);
    } else if (window.platform.name === 'ios') {
      location.href =
      'itms-apps://itunes.apple.com/cn/app/%E5%8D%9A%E6%AF%85/id1448458716?mt=8';
    } else {
      // window.location.href = this.upgrade.address;
      cordova.InAppBrowser.open(this.upgrade.address, '_system');
    }
  }
  public async updateAndroid(url) {
    return new Promise((resolve, reject) => {
      window.AppUpdate.install((msg) => {
        console.log(msg);
        resolve(msg);
      }, (error) => {
        reject(error);
        console.log(error);
      }, url);
    });
  }
  // 稍后升级
  public handleLaterUp() {
    this.$emit('laterUp');
  }

}



// WEBPACK FOOTER //
// ./src/views/components/UpgradeApp/UpgradeApp.ts